export default __webpack_public_path__ + "static/media/placeholdercar3.7d859a29.png";